import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { AddButton } from '../../CustomButtons';
import { CancelButton } from '../../SubComponents';
import { IMonthlyOrderOrder } from '../../../interfaces';
import { useMonthlyOrder, useMonthlyOrderAvailableOrders } from '../../../hooks/stores/useMonthlyOrderStores';
import { getMonthlyOrderAvailableOrdersById, postMonthlyOrderLinkUnlinkOrder } from '../../../middleware';
import { FormSelect } from '../../Forms';
import Styles from '../m_styles.less';

type IMonthlyOrderAddOrder = {
    onFinish: () => void;
};
export const MonthlyOrderAddOrder: React.FC<IMonthlyOrderAddOrder> = observer(({ onFinish }: IMonthlyOrderAddOrder) => {
    const availableList = useMonthlyOrderAvailableOrders();
    const [selectedOrderId, setSelectedOrderId] = React.useState<string | undefined>();

    const { id, linkedOrders } = useMonthlyOrder();

    const exceptionIds = linkedOrders?.map((order: IMonthlyOrderOrder) => order.id.toString());

    const addOrder = async (): Promise<void> => {
        if (id && selectedOrderId) {
            await postMonthlyOrderLinkUnlinkOrder({
                monthlyOrder: id!.toString(),
                orderId: selectedOrderId,
                linkening: true,
            });
        }
        onFinish();
    };

    useEffect(() => {
        if (id) {
            getMonthlyOrderAvailableOrdersById(id.toString());
        }
    }, [id]);

    return (
        <div className={Styles.monthlyOrderAddOrder}>
            {availableList.length ? (
                <div className={Styles.selector}>
                    <FormSelect
                        dataTest={'MonthlyOrderAddOrderItemSelect'}
                        exceptionIds={exceptionIds}
                        fieldName={'orderId'}
                        isShortForm
                        useSelectHook={useMonthlyOrderAvailableOrders}
                        onChange={(id) => {
                            setSelectedOrderId(Array.isArray(id) ? id[0] : id);
                        }}
                    />
                </div>
            ) : (
                <div className={Styles.emptyListMessage}>{"We don't have any available Orders"}</div>
            )}
            <div className={Styles.buttonsPlace}>
                <AddButton onClick={addOrder} disabled={!selectedOrderId} />
                <CancelButton isHideIcon onClick={onFinish} />
            </div>
        </div>
    );
});
